import styled from "styled-components";
import { colors } from "../../../theme/theme";

export const LoaderWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 40px;
	justify-content: center;
	align-items: center;
	height: 100%;
	min-height: 200px;

	&.expand-vertically {
		position: fixed;
		height: 300px;
		width: 100%;
		max-width: 500px;
		border-radius: 8px;
		z-index: 200;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);

		background: ${colors.greyscale.white};
		color: ${colors.greyscale.black};
	}
`;

interface IModalLoader {
	/** A altura x largura do loader */
	size: number;
	/** A espessura da barra */
	thickness: number;
}

export const ModalLoader = styled.div<IModalLoader>`
	width: ${(props) => (props.size ? props.size : 48)}px;
	height: ${(props) => (props.size ? props.size : 48)}px;
	border-radius: 50%;
	display: inline-block;
	position: relative;
	background: linear-gradient(
		0deg,
		hsla(159, 57%, 50%, 0.301) 13%,
		${colors.mainColors.verde_dstore} 100%
	);
	box-sizing: border-box;
	animation: rotation 1s linear infinite;

	::after {
		content: "";
		box-sizing: border-box;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		width: ${(props) =>
			props.thickness
				? props.size
					? props.size - props.thickness
					: 48 - props.thickness
				: 44}px;
		height: ${(props) =>
			props.thickness
				? props.size
					? props.size - props.thickness
					: 48 - props.thickness
				: 44}px;
		border-radius: 50%;
		background: ${colors.greyscale.white};
	}
	@keyframes rotation {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
`;
